window.presetBundle = (async function () {
    const itemsContainer = `.pre-bundle-products-list`;
    const scrollHint = "#scrollHint";
    const atcBtns = '.pre-bundle-atc-btn,#js-sticky-btn';
    const editBtn = '.bundle-edit-btn';
    const saveBtn = '.bundle-save-btn';
    const minusBtn = '.pre-bundle-qty-btn-minus';
    const cartMinusBtn = ".js-qty__adjust--minus"
    const cartQtyInput = "#Quantity";
    const suggestionsContainer = ".pre-bundle-search-result";
    const searchContainer = ".pre-bundle-search-bar";
    const searchLoader = ".pre-bundle-search-bar .spinner-border";
    const searchInput = ".pre-search-product";
    const cartPlusBtn = ".js-qty__adjust--plus"
    const plusBtn = '.pre-bundle-qty-btn-plus';
    const removeBtn = '.pre-bundle-remove-product';
    const preItemsSection = "#pre-bundle-section";
    const preBtnSection = ".product-form__quantity-submit";
    const sellingPlanInput = ".product-form input[name='selling_plan']"
    const qtyInput = ".pre-bundle-qty-input";
    const searchItem = ".pre-bundle-search-item";
    const pageLoader = `#preset-bundle-loader`;
    const stickyCart = `.sticky-cart-wr`;
    const sellingPlanSelectorInput = `.selling_plan_widget_integration input[type="radio"]`;
    const sellingPlanOptionsSelect = `.selling-plan-options select`

    const apollo = {
        presetVariantsInitial: window.presetVariantsInitial ?? [],
        presetVariants: [],
        cart: {},
        suggestions: [],
        cartQty: 1,
        debounceTimer: undefined,
        searchController: undefined,
        getCurrencyFormat: function () {
            return Currency.moneyFormats?.[Shopify.currency.active]?.[Currency.format];
        },
        isOnetime: function(){
            return $(sellingPlanInput).val() === "" || !$(sellingPlanInput).val()
        },
        generateSubscriptionDis: function(){
            return {
                discount:{
                    value: 10,
                    type: 'percentage'
                },
                attr: {}
            }
        },
        generateOnetimeDis: function(checkIfOnetimePurchase = false){
            const cartItems = Object.values(this.cart);
            const qty = this.presetVariantsInitial.reduce((sum, item) => sum + (item.quantity || 0), 0);
            const cartQty = cartItems.reduce((sum, item) => sum + (item.quantity || 0), 0);
            // these are from app stle bundle
            const discountRule = window._ABConfig?.bundle_rules?.find(item => item.internalName?.trim().toLowerCase() === "preset bundle onetime discount 5%")

            if((checkIfOnetimePurchase && !this.isOnetime()) || !discountRule || cartQty < qty) return {discount: null, attr: {}};

            const disValue = discountRule.discountValue;
            const disType = discountRule.discountType;
            return {
                discount: {
                    value: disValue,
                    type: disType?.toLowerCase(),
                },
                attr: {
                    "_appstle-bb-id":discountRule.uniqueRef,
                    "__appstle-bb-name":discountRule.name,
                    "_appstle-bundles-variants":cartItems[0]?.variant.id,
                    "_appstle_bundles_type":discountRule.bundleType,
                    "_appstle_bundle_mandatory_products":"[]",
                }
            }
        },
        getVariantDetails: async function () {
            const query = `
            query getVariants($ids: [ID!]!) {
                nodes(ids: $ids) {
                    ... on ProductVariant {
                        id
                        title
                        price{
                            amount
                            currencyCode
                        }
                        compareAtPrice{
                            amount
                            currencyCode
                        }
                        availableForSale
                        image {
                            url
                            altText
                        }
                        product {
                            title
                            variantsCount{
                                count
                            }
                            featuredImage {
                                url
                                altText
                            }
                        }
                    }
                }
            }
        `;
            const variants = this.presetVariantsInitial.map(v => v.variant);
            const variables = { ids: variants };

            const res = await fetch("/api/2025-10/graphql.json", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ query, variables })
            });

            const data = await res.json();
            const nodes = data?.data?.nodes?.map(node => {
                const id = node.id.split("/").pop();
                const presetVariant = this.presetVariantsInitial.find(v => v.variant.split("/").pop() === id);
                return {
                    variant: {
                        ...node,
                        id: parseInt(id),
                        price: node.price.amount * 100,
                        compareAtPrice: node.compareAtPrice?.amount * 100 ?? null,
                    },
                    product: node.product,
                    quantity: presetVariant?.quantity || 1
                }
            }) ?? [];
            const cartItems = {};
            nodes.forEach(item => {
                cartItems[item.variant.id] = item;
            });
            return cartItems;
        },
        hadleScrollHint: function(){
            const container = $(itemsContainer)[0];
            console.log("my height", container, container.scrollHeight,container.clientHeight)
            if (container.scrollHeight > container.clientHeight) {
                $(scrollHint).css("opacity", 1)
            } else {
                $(scrollHint).css("opacity", 0)
            }
        },
        renderSuggestions: function () {
            let html = '';
            this.suggestions.forEach(product => {
                const imageSrc = product.featuredImage?.url;
                const image = imageSrc ? imageSrc.replace(/(\.[^.]*)$/, '_50x50$1') : '';
                const price = theme.Currency.formatMoney(product.price, this.getCurrencyFormat());

                html += `
                    <div class="pre-bundle-search-item ${product.variantsCount.count > 1 ? 'js-btn-quickview' : ""}" ${product.variantsCount.count > 1 ? `data-pavailable="true" data-handle="${product.handle}" data-toggle="modal" data-target="#jsQuickview"` : ''} data-product="${product.id}">
                        <div class="d-inline-flex 0">
                            <span class="image">
                                <img src="${image}">
                            </span>
                            <div class="meta">
                                <p class="title">${product.title}</p>${price}
                            </div>
                        </div>
                    </div>
                `
            });
            if (html === "") {
                html = `<p class="text-center">No results.</p>`
            }
            $(suggestionsContainer).html(html);
            $(suggestionsContainer).addClass("active")
        },
        getSuggestions: function (signal) {
            const q = $(searchInput).val();
            if (q.length <= 0) {
                this.suggestions = [];
                this.renderSuggestions();
                $(searchLoader).hide();
                return;
            }

            const query = `
            query searchProductsWithVariants($query: String!) {
                products(first: 10, query: $query) {
                    nodes {
                        id
                        title
                        handle
                        variantsCount{
                            count
                        }
                        featuredImage {
                            url
                            altText
                        }
                        options{
                            name
                            values
                        }
                        priceRange{
                            minVariantPrice {
                                amount
                                currencyCode
                            }
                            maxVariantPrice {
                                amount
                                currencyCode
                            }
                        }
                        variants(first: 100) {
                            nodes {
                                id
                                title
                                price{
                                    amount
                                    currencyCode
                                }
                                compareAtPrice{
                                    amount
                                    currencyCode
                                }
                                selectedOptions {
                                    name
                                    value
                                }
                                availableForSale
                                image {
                                    url
                                    altText
                                }
                            }
                        }
                    }
                }
            }
            `
            fetch("/api/2025-10/graphql.json", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ query, variables: { query: `*${q}* -id:${$(preItemsSection).data("product")}` } }),
                signal: signal
            }).then(response => response.json())
                .then(res => {
                    this.suggestions = res.data.products.nodes.filter(p => !p.title?.toLowerCase().includes("bundle")).map(product => {
                        return {
                            ...product,
                            id: parseInt(product.id.split("/").pop()),
                            price: product.priceRange.minVariantPrice.amount * 100,
                            variants: product.variants.nodes.map(variant => {
                                return {
                                    ...variant,
                                    id: parseInt(variant.id.split("/").pop()),
                                    price: variant.price.amount * 100,
                                    compareAtPrice: variant.compareAtPrice?.amount * 100 ?? null,
                                }
                            })
                        }
                    });
                    this.renderSuggestions();
                    $(searchLoader).hide();
                })
        },
        showSuccessAlert: function (message) {
            theme.alert.new('Success', message, 3000, 'notice');
        },
         showErrorAlert: function (message) {
            theme.alert.new('',message,3000,'warning');
        },
        handleRemoveProduct: function (removeBtnSelector) {
            const btn = $(removeBtnSelector);
            const variantId = btn.attr('data-variant');
            const item = this.cart[variantId];
            if (!item) return;

            delete this.cart[variantId];
            this.showSuccessAlert(`Removed ${item.product.title}${item.product.variantsCount.count > 1 ? ` - ${item.variant.title}` : ''} from cart.`);

            this.calculateCartTotal();
            this.renderCartItems();
        },
        increaseCartItemQuantity: function (btnSelector) {
            const variantID = $(btnSelector).attr('data-variant');
            const variantId = parseInt(variantID);
            const item = this.cart[variantId];
            if (!item) return;
            this.cart[variantId].quantity += 1;
            this.calculateCartTotal();
            this.renderCartItems();
        },
        decreaseCartItemQuantity: function (btnSelector) {
            const variantID = $(btnSelector).attr('data-variant');
            const variantId = parseInt(variantID);
            const item = this.cart[variantId];
            if (!item) return;
            if (item.quantity > 1) {
                this.cart[variantId].quantity -= 1;
            } else {
                delete this.cart[variantId];
            }
            this.calculateCartTotal();
            this.renderCartItems();
        },
        setCartItemQuantity: function (inputSelector) {
            const input = $(inputSelector);
            const variantID = input.attr('data-variant');
            const quantity = input.val();
            const variantId = parseInt(variantID);
            const qty = parseInt(quantity);
            const item = this.cart[variantId];
            if (!item) return;
            if (qty <= 0) {
                delete this.cart[variantId];
            } else {
                this.cart[variantId].quantity = qty;
            }
            this.calculateCartTotal();
            this.renderCartItems();
        },
        increaseBundleQty: function () {
            this.cartQty++
            this.calculateCartTotal();
        },
        decreaseBundleQty: function () {
            if (this.cartQty > 1) {
                this.cartQty--
            }
            this.calculateCartTotal();
        },
        setBundleQty: function () {
            const val = $(cartQtyInput).val();
            if (!isNaN(val)) {
                const valNum = Number(val);
                if (valNum <= 0) {
                    $(cartQtyInput).val(this.cartQty)
                } else {
                    this.cartQty = val;
                }
                this.calculateCartTotal();
            }
        },
        renderCartItems: function () {
            let html = '';
            let qtyController = (variantID, qty) => `<div class="pre-bundle-qty-control">
            <button type="button" class="pre-bundle-qty-btn pre-bundle-qty-btn-minus" data-variant="${variantID}"><i class="icon-minus"></i></button>
                <input type="text" class="pre-bundle-qty-input" value="${qty}" data-variant="${variantID}">
            <button type="button" class="pre-bundle-qty-btn pre-bundle-qty-btn-plus" data-variant="${variantID}"><i class="icon-plus"></i></button>
            </div>`

            Object.values(this.cart).reverse().forEach(item => {
                const imageSrc = item.variant.image?.url ?? item.product.featuredImage?.url;
                const image = imageSrc ? imageSrc.replace(/(\.[^.]*)$/, '_240x240$1') : '';
                const price = theme.Currency.formatMoney(item.variant.price * item.quantity, this.getCurrencyFormat());

                html += `
                <div class="pre-bundle-product-item">
                    <img src="${image}" alt="${item.product.title}" class="pre-bundle-product-image">
                    <div class="pre-bundle-product-info">
                    ${qtyController(item.variant.id, item.quantity)}
                    <h4 class="pre-bundle-product-name">${item.product.title} <span class="pre-bundle-item-qty">x${item.quantity}</span></h4>
                    ${item.product.variantsCount.count > 1 ? `<span class="pre-bundle-product-variant d-block">${item.variant.title}</span>` : ''}
                    <span class="pre-bundle-product-price">${price}</span>
                    </div>
                    <button type="button" class="pre-bundle-remove-product" data-variant="${item.variant.id}">×</button>
                </div>
                `
            })

            if (html === '') {
                $(itemsContainer).html(`<div class="pre-bundle-product-empty">${$(itemsContainer).attr("data-empty_txt")}</div>`)
                $(atcBtns).addClass("btn-disabled");
                $(atcBtns).prop("disabled", true)
            } else {
                $(itemsContainer).html(html);
                $(atcBtns).removeClass("btn-disabled");
                $(atcBtns).prop("disabled", false)
            }
        },
        showEditing: function () {
            $(preItemsSection).addClass("pre-bundle-editing");
            $(preBtnSection).addClass("pre-bundle-editing");
        },
        hideEditing: function () {
            $(preItemsSection).removeClass("pre-bundle-editing");
            $(preBtnSection).removeClass("pre-bundle-editing");
        },
        setATCStatus: function () {
            const hasCartItem = Object.keys(this.cart).length > 0;
            if (hasCartItem) {

            }
        },
        calculateCartTotal: function () {
            let total = 0;
            let quantity = 0;
            let totalCount = 0;
            for (const key in this.cart) {
                const item = this.cart[key];
                total += item.variant.price * item.quantity;
                quantity += item.quantity;
                totalCount += 1;
            }
            const totalPrice = total * this.cartQty;
            const onetimeDis = this.generateOnetimeDis().discount;
            const subDis = this.generateSubscriptionDis().discount
            let discountedPrice = totalPrice;
            let discount = null;
            
            if(this.isOnetime() && onetimeDis){
                discount = onetimeDis;
            }else if(!this.isOnetime() && subDis){
                discount = subDis;
            }
            if(discount){
                discountedPrice = Math.max(totalPrice - (discount.type === 'percentage' ? (totalPrice * discount.value)/100 : discount.value), 0);
            }

            const onetimePrice = Math.max(totalPrice - (onetimeDis?.type === 'percentage' ? (totalPrice * onetimeDis?.value ?? 0)/100 : onetimeDis?.value ?? 0), 0)
            const subPrice = Math.max(totalPrice - (subDis?.type === 'percentage' ? (totalPrice * subDis?.value ?? 0)/100 : subDis?.value ?? 0), 0)
            const totalPriceFormated = theme.Currency.formatMoney(totalPrice, this.getCurrencyFormat());

            $(`.plan-price.one-time-price`).parent().find(".title-with-radio h6 .save-badge").remove()
            if(onetimeDis){
                const amount = onetimeDis.type == 'percentage' ? `${onetimeDis.value}%` : theme.Currency.formatMoney(onetimeDis.value * 100, this.getCurrencyFormat());
               $(`.plan-price.one-time-price`).parent().find(".title-with-radio h6").append(`<span class="save-badge">Save ${amount}</span>`)
            }
            $(`.plan-price:not(.one-time-price)`).parent().find(".title-with-radio h6 .save-badge").remove()
            if(subDis){
                const amount = subDis.type == 'percentage' ? `${subDis.value}%` : theme.Currency.formatMoney(subDis.value * 100, this.getCurrencyFormat());
               $(`.plan-price:not(.one-time-price)`).parent().find(".title-with-radio h6").append(`<span class="save-badge">Save ${amount}</span>`)
            }
            $(`.plan-price:not(.one-time-price)`).html(theme.Currency.formatMoney(subPrice, this.getCurrencyFormat()) + `${subPrice < totalPrice ? `<s>${totalPriceFormated}</s>` : ""}`).attr("data-amount", subPrice)
            $(`.plan-price.one-time-price`).html(theme.Currency.formatMoney(onetimePrice, this.getCurrencyFormat()) + `${onetimePrice < totalPrice ? `<s>${totalPriceFormated}</s>` : ""}`).attr("data-amount", onetimePrice)

            $(`.product-single__price,.product-card__price`).text(theme.Currency.formatMoney(discountedPrice, this.getCurrencyFormat())).attr("data-amount", discountedPrice);
            $(`.pre-bundle-count`).text(totalCount);
            if(discountedPrice < totalPrice){
                $(".product-single__price.product-single__price--compare").text(totalPriceFormated).show();
            }else{
                $(".product-single__price.product-single__price--compare").hide();
            }
            // floatCartCount.text(quantity);
        },
        addProductToCart: async function (atcButtonSelector, isModalAtc = false) {
            const btn = $(atcButtonSelector);
            const productId = btn.attr('data-product');
            const parent = btn.closest(isModalAtc ? '.modal' : searchItem);
            const variantOption = parent.find(isModalAtc ? ".qv-add-to-cart select" : '.bundle-variant-select').val();
            const product = this.suggestions.find(p => p.id == productId);
            if (!product) return;
            let variant = product.variants[0];
            if (variantOption && variantOption !== '') {
                const matchedVariant = product.variants.find(v => v.title.includes(variantOption));
                if (matchedVariant) {
                    variant = matchedVariant;
                }
            }

            const variantExist = this.cart[variant.id];
            if (variantExist) {
                this.cart[variant.id].quantity += 1;
                this.showSuccessAlert(`Added another ${product.title}${product.variants.length > 1 ? ` - ${variant.title} ${product.title}` : ''} to cart.`);
            } else {
                this.cart[variant.id] = {
                    variant: variant,
                    quantity: 1,
                    product: product
                };
                this.showSuccessAlert(`Added ${product.title}${product.title}${product.variants.length > 1 ? ` - ${variant.title} ${product.title}` : ''} to cart.`);
            }

            this.calculateCartTotal();
            this.renderCartItems();
        },
        updateCartAjax: async function () {
            const dataToAdd = [];
            const sellingPlan = $(`${sellingPlanSelectorInput}:checked`).closest('label.radio').find('select').val();
            const randomBundleID = Math.random().toString(36).substring(2, 15);
            const products = Object.values(this.cart).reverse();

            products.forEach((item, index) => {
                const d = {
                    id: item.variant.id,
                    quantity: item.quantity * this.cartQty,
                    properties: {
                        _preset_bundle_item: true,
                        _preset_bundle_action_id: randomBundleID,
                        _total_bundle_products: products.length,
                        _product_position_order: index + 1,
                        _preset_bundle_title: $(preItemsSection).data("title"),
                        _preset_bundle_image: $(preItemsSection).data("image"),
                        _preset_bundle_handle: $(preItemsSection).data("handle"),
                        ...this.generateOnetimeDis(true).attr,
                    }
                };

                if (sellingPlan) {
                    d.selling_plan = sellingPlan;
                }
                dataToAdd.push(d);
            })

            return await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: dataToAdd
                })
            })
                .then(r => r.json())
        },
        initializeData: async function () {
            const cartData = await this.getVariantDetails();
            this.cart = cartData;
            this.renderCartItems();
            this.calculateCartTotal();
        }
    }

    if (apollo.presetVariantsInitial.length) {
        $(pageLoader).show();
        await apollo.initializeData();
        $(pageLoader).hide();
        if (stickyCart) {
            $(stickyCart)[0].style.setProperty("display", "flex", "important");
            console.log("showing sticky cart", $(stickyCart)[0])
        }

        $(document).on("click", editBtn, function () {
            apollo.showEditing();
        })

        $(document).on("click", saveBtn, function () {
            apollo.hideEditing();
        })

        $(document).on("click", removeBtn, function () {
            apollo.handleRemoveProduct($(this))
        })
        $(document).on("click", plusBtn, function () {
            apollo.increaseCartItemQuantity($(this))
        })
        $(document).on("click", minusBtn, function () {
            apollo.decreaseCartItemQuantity($(this))
        })
        $(document).on("change", qtyInput, function () {
            apollo.setCartItemQuantity($(this))
        })
        $(document).on("click", cartPlusBtn, function () {
            apollo.increaseBundleQty()
        })
        $(document).on("click", cartMinusBtn, function () {
            apollo.decreaseBundleQty()
        })
        $(document).on("change", cartQtyInput, function () {
            apollo.setBundleQty()
        })
        $(document).on("click", "body", function (e) {
            if (!$(e.target).closest(suggestionsContainer).length && !$(e.target).closest(searchContainer).length) {
                $(suggestionsContainer).removeClass("active");
            }
        })
        $(document).on("input", searchInput, function () {
            $(searchLoader).show();
            apollo.searchController?.abort();

            // Clear previous debounce
            clearTimeout(apollo.debounceTimer);

            // Create new abort controller
            apollo.searchController = new AbortController();

            // Debounce the API call
            apollo.debounceTimer = setTimeout(() => {
                apollo.getSuggestions(apollo.searchController.signal);
            }, 300);
        })
        $(document).on("click", searchItem, function () {
            if (!$(this).hasClass("js-btn-quickview")) {

            }
        })

        document.addEventListener("click", function (ev) {
            if (ev.target.closest(".bundle-btn-cta-qv") == null) return;
            ev.preventDefault();
            ev.stopImmediatePropagation();
            apollo.addProductToCart($(".bundle-btn-cta-qv"), true);
            $('#jsQuickview').modal("hide")
            $(suggestionsContainer).removeClass("active");
        }, true)
        // $(document).on("click", '.bundle-btn-cta-qv', function (ev) {
        //     ev.preventDefault();
        //     ev.stopImmediatePropagation();
        //     apollo.addProductToCart($(this), true);
        //     $('#jsQuickview').modal("hide")
        //     $(suggestionsContainer).removeClass("active");
        // })
        $(document).on("click", searchItem, function () {
            if (!$(this).hasClass("js-btn-quickview")) {
                apollo.addProductToCart($(this), false);
                $(suggestionsContainer).removeClass("active");
            }
        })
        $(document).on("change", `${sellingPlanSelectorInput},${sellingPlanOptionsSelect}`, function(){
            apollo.calculateCartTotal()
        })
        document.querySelectorAll(atcBtns).forEach(btn => {
            btn.addEventListener("click", async function (ev) {
                const btn = $(atcBtns);
                const cartURL = $(preItemsSection).data("cart_url");
                // const preHtml = [];
                // btn.each(function() {
                //     preHtml.push($(this).html());
                // });
                if (btn.hasClass("btn-disabled")) {
                    ev.preventDefault();
                    ev.stopImmediatePropagation();
                    return;
                } else {
                    ev.preventDefault();
                    ev.stopImmediatePropagation();
                    let preInner = btn.html();
                    let loader = `<div class="spinner-border" style="height: 15px; width: 15px;border-width: 3px;" role="status"><span class="sr-only">Loading...</span></div>`;
                    btn.html(loader);
                    btn.prop("disabled", true);
                    await apollo.updateCartAjax().then(res => {
                        if(!!res.items || !res.status || res.status === 200){
                            window.location.href = cartURL;
                        }else{
                            apollo.showErrorAlert(res.description ?? "Something went wrong!")
                            btn.html(preInner)
                            btn.prop("disabled", false);
                        }
                    });
                }
            }, { capture: true })
        })

        apollo.hadleScrollHint();
        $(itemsContainer).on("scroll", function(){
            $(scrollHint).css("opacity", 0)
        })
    }
    return apollo;
})();